export const GET_REGIONS = 'GET_REGIONS';
export const GET_ALLREGIONS = 'GET_ALLREGIONS';
export const SET_REGIONS = 'SET_REGIONS';
